import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBillableIntervalAnalytic } from "app/services/dashboard/billableIntervalAnalyticService";
import { BASE_URL } from "static/constants";

export const billableIntervalAnalyticApi = createApi({
  reducerPath: "transmissionIntervalAnalyticApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getBillableIntervalAnalytic: builder.query({
      queryFn: ({ account, startDate, endDate, interval }) => {
        return {
          data: getBillableIntervalAnalytic({
            account,
            startDate,
            endDate,
            interval,
          }),
        };
      },
      keepUnusedDataFor: 5,
    }),
  }),
});

export const { useGetBillableIntervalAnalyticQuery } =
  billableIntervalAnalyticApi;
